// useThreadTones — bulk tone classification for a conversation's inbound
// messages. Posts the list of message ids to POST /api/ai/tone/bulk and
// returns a Record<messageId, MessageTone>. Cached on the backend per
// message_id (see message_tones table), so subsequent loads are instant.
//
// This is a fire-and-forget enhancement: if classification fails, we return
// an empty map and ThreadView just omits the tone chips. No loading state
// exposed because chip-or-no-chip is both acceptable.

import { useMutation } from '@tanstack/react-query';
import { apiPost } from '@/lib/api';
import type { MessageTone } from '@/components/center/ToneChip';

export interface ToneBulkResponse {
  ok: true;
  tones: Record<string, MessageTone>;
}

export function useThreadTones() {
  return useMutation<ToneBulkResponse, Error, { messageIds: string[] }>({
    mutationFn: (vars) =>
      apiPost<ToneBulkResponse, { message_ids: string[] }>('/api/ai/tone/bulk', {
        message_ids: vars.messageIds,
      }),
  });
}
